
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiContentCutGoogle as ObiContentCutGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-content-cut-google.js';
 
 
 

 
 export const ObiContentCutGoogle = createComponent({
   react: React,
   tagName: 'obi-content-cut-google',
   elementClass: ObiContentCutGoogleElement,
   events: {
     
   }
  });
 
 